<!-- 
화면명 : UCButton.vue
작성일 : 2025-07-01
설명   : 버튼 컨트롤
-->
<template>
  <div class="flex items-center space-x-2">
    <button
    class="px-2 py-1.5 ml-1 flex items-center justify-center text-xs font-medium text-gray-800 bg-gradient-to-b from-white to-gray-200 border border-gray-400 rounded-sm shadow-sm hover:from-gray-50 hover:to-gray-300 active:from-gray-200 active:to-gray-300"
      :class="customClass"
      :style="{ width: widthStyle }">
      <img :src="srcIcon" class="w-5 h-5 mr-1" v-if="srcIcon" />
      {{ label }}
    </button>
  </div>
</template>

<script setup>
import { ref, defineProps, computed } from "vue";

import iconSearch from "@/assets/img/btn-search.svg";
import iconExcel from "@/assets/img/btn-excel.svg";
import iconPrinter from "@/assets/img/btn-printer.svg";
import iconDelete from "@/assets/img/btn-delete.svg";
import iconAllread from "@/assets/img/btn-allread.svg";
import iconSave from "@/assets/img/btn-save.svg";
import iconClose from "@/assets/img/blue-close.svg";
import iconLock from "@/assets/img/btn-lock.svg";

const props = defineProps({
  label: {
    type: String,
    default: "",
  },
  width: {
    type: [String, Number],
    default: "100%",
  },
  customClass: {
    type: [String, Object, Array],
    default: "",
  },
  icon: {
    type: String,
    default: "",
  },
});

// width 계산
const widthStyle = computed(() => {
  return typeof props.width === "number" ? `${props.width}px` : props.width;
});

const srcIcon = computed(() => {
  let result;

  if (props.icon === "search") {
    result = iconSearch;
  } else if (props.icon === "excel") {
    result = iconExcel;
  } else if (props.icon === "printer") {
    result = iconPrinter;
  } else if (props.icon === "delete") {
    result = iconDelete;
  } else if (props.icon === "allread") {
    result = iconAllread;
  } else if (props.icon === "save") {
    result = iconSave;
  } else if (props.icon === "close") {
    result = iconClose;
  } else if (props.icon === "lock") {
    result = iconLock;
  }

  return result;
});
</script>
